import SeoPageLayout from "@/components/SeoPageLayout";

const KabaretNaBankiet = () => (
  <SeoPageLayout title="Kabaret na bankiet - rozrywka przy eleganckim stole">
    <p>
      Bankiet to wydarzenie, które łączy wyśmienitą kuchnię z wyjątkową atmosferą. Kabaret na bankiet to idealne uzupełnienie programu - dostarcza rozrywki między daniami i sprawia, że goście doskonale się bawią, nie wstając od stołu.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret bankietowy - specyfika formatu</h2>
    <p>
      Występ kabaretowy na bankiecie wymaga szczególnego podejścia. Artyści grają dla publiczności siedzącej przy stołach, często w trakcie posiłku. Wymaga to doskonałego wyczucia czasu, głośniejszej projekcji głosu i materiału, który angażuje nawet w mniej sprzyjających akustycznie warunkach.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kiedy zaplanować kabaret na bankiecie?</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Między przystawkami a daniem głównym - krótki, 15-minutowy występ</li>
      <li>Po deserze - pełnowymiarowy 30-45 minutowy show</li>
      <li>Jako highlight wieczoru - centralny punkt programu bankietu</li>
      <li>Na zakończenie - humorystyczne podsumowanie wieczoru</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Rodzaje bankietów z kabaretem</h2>
    <p>
      Kabaret sprawdza się na każdym typie bankietu - od firmowych kolacji biznesowych, przez bankiety weselne, jubileuszowe, po eleganckie kolacje prywatne. Kluczem jest dopasowanie stylu i tematyki do charakteru wydarzenia i oczekiwań gości.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Wymagania przestrzenne</h2>
    <p>
      Na bankiecie nie zawsze jest dedykowana scena - i nie zawsze jest potrzebna. Nasi artyści potrafią występować zarówno na dużych scenach, jak i w kameralnych przestrzeniach między stołami. Jedyne, czego potrzebujemy, to mikrofon i odrobina wolnej przestrzeni.
    </p>
  </SeoPageLayout>
);

export default KabaretNaBankiet;
